import { Box, Button, Card, Checkbox, ClickAwayListener, Fade, Grid, Tooltip, Typography } from "@material-ui/core"
import { isEmpty } from "lodash";
import { useCallback, useState } from "react";
import { ProcessoProdutoSetorModel } from "../../../../model/api/processo-produto-setor/processo-produto-setor-model";
import { EnumStatusPedido } from "../../../../model/enums/enum-status-pedido";
import { AvancarIcon, InformacaoIcon, VoltarIcon } from "../../icons";
import { useStyles } from "./card-item-pedido-styles";
import { useThemeQueries } from "../../../theme";
import { AdicionarRemoverProcessos } from "../../../../model/app/forms/adicionar-remover-processos/adicionar-remover-processos";
import { CancelIcon } from "../../icons/cancel-icon";
import CardInfoProdutoSubItem from "../card-info-produto-subitem/card-info-produto-subitem";
import { AssinaturaIcon } from "../../icons/assinatura-icon";
import { DialogSaurus } from "../../dialog/dialog-saurus/dialog-saurus";

type Props = {
   pedidoFinalizado?: string,
   botaoFinalizar?: boolean,
   finalizado?: boolean,
   model: ProcessoProdutoSetorModel;
   processosSelecionados: AdicionarRemoverProcessos[];
   setFinalizado?: (valor: boolean) => void;
   proximo: (id: string[]) => Promise<void>
   anterior: (id: string[]) => Promise<void>
   onClickAtt?: () => Promise<void>
   estaCancelado: (id: string[]) => Promise<void>
   setProcessosSelecionados: React.Dispatch<React.SetStateAction<AdicionarRemoverProcessos[]>>
   esconderCheckboxSeRetiradaOuEntrega: () => boolean
}

export const CardItemPedido = ({
   model,
   botaoFinalizar,
   processosSelecionados,
   proximo,
   anterior,
   onClickAtt,
   estaCancelado,
   setProcessosSelecionados,
   esconderCheckboxSeRetiradaOuEntrega
}: Props) => {
   const classes = useStyles();
   const [openTooltip, setOpenTooltip] = useState<boolean>(false)
   const [isDialogOpenned, setIsDialogOpenned] = useState<boolean>(false)
   const [imagemAssinada, setImagemAssinada] = useState<string>('')

   const { theme, isMobile } = useThemeQueries()
   const expiryTimestamp = useCallback(() => new Date(model.systemInsertDate), [model.systemInsertDate])
   expiryTimestamp().setSeconds(expiryTimestamp().getSeconds() + model.minutosDePreparo * 60)

   // const temProximo = model.processos.map(processo => processo.processoProducao).filter(item => item > model.processoProducaoAtual)
   const isCancelado = model.status.codigo >= EnumStatusPedido.SolicitacaoCancelamentoAtendimento
   const isConcluido = model.status.codigo === EnumStatusPedido.Finalizado

   const alterarCorStatus = useCallback(() => {
      const horaAgora = new Date()
      if (horaAgora > expiryTimestamp()) {
         if (isConcluido) {
            return theme.palette.success.main
         } else if (model.minutosDePreparo !== null) {
            return theme.palette.primary.main
         }
      } else if (horaAgora < expiryTimestamp()) {
         if (isConcluido) {
            return theme.palette.success.main
         } if (isCancelado) {
            return theme.palette.error.light
         }
         return theme.palette.primary.main
      }
   }, [expiryTimestamp, isCancelado, isConcluido, model.minutosDePreparo, theme.palette.error.light, theme.palette.primary.main, theme.palette.success.main])

   const alterarCorStatusSemMinutos = useCallback(() => {
      //Se o status for igual a 1 (PRODUÇÃO)
      if (model.status.codigo === 1) {
         return theme.palette.primary.main
      }
      else if (model.status.codigo === 2) {
         return theme.palette.primary.main
      }
      else if (isConcluido) {
         return theme.palette.success.main
      }
      else if (isCancelado) {
         return theme.palette.error.light
      }
   }, [isCancelado, isConcluido, model.status.codigo, theme.palette.error.light, theme.palette.primary.main, theme.palette.success.main])

   const corCancelado = useCallback(() => {
      if (isCancelado && model.processoProducaoAtual < 9000)
         return "#FFDFDF"
   }, [isCancelado, model.processoProducaoAtual])

   const handleCloseTooltip = useCallback(() => setOpenTooltip(false), [])

   const handleOpenTooltip = useCallback(() => setOpenTooltip(prev => !prev), [])

   const adicionarRemoverProcessos = useCallback(() => {
      const processos = processosSelecionados
      const selecionado = processos.find(x => x.produtoId === model.id)
      const processosDiferentes = processos.filter(x => x.produtoId !== model.id).filter(x => x.groupId !== selecionado?.codigoReferencia);

      if (isEmpty(selecionado)) {
         const subItens = [...model.produto.inclusos, ...model.produto?.adicionais ?? []]
         const select = [{ produtoId: model.id, groupId: null, codigoReferencia: model.produto.codigoReferencia, pedidoId: model.pedidoId }, ...subItens.map(x => ({
            produtoId: x.codigoReferencia,
            groupId: x.groupId,
            codigoReferencia: x.codigoReferencia,
            pedidoId: x.pedidoId,
         }))]

         return setProcessosSelecionados(prev => [...prev, ...select]);
      }

      setProcessosSelecionados!([...processosDiferentes])

   }, [model, processosSelecionados, setProcessosSelecionados])

   const botaoAnterior = !(model.status.codigo <= EnumStatusPedido.AguardandoInicio) && !(model.status.codigo >= EnumStatusPedido.SolicitacaoCancelamentoAtendimento);

   const botaoAvancar = model.status.codigo < EnumStatusPedido.Finalizado;

   const botaoCancelar = model.status.codigo === EnumStatusPedido.SolicitacaoCancelamentoAtendimento;

   const mostrarCorCard = [
      EnumStatusPedido.SolicitacaoCancelamentoAtendimento,
      EnumStatusPedido.SolicitacaoCancelamentoProducao
   ].includes(model.status.codigo)

   const abrirAssinaturaProduto = () => {
      try {
         setImagemAssinada(model.processos.find(x => x.uriConfirmacao)?.uriConfirmacao ?? '')
         setIsDialogOpenned(true)

         // window.open(model.processos.find(x => x.uriConfirmacao)?.uriConfirmacao, '_blank');
      } catch (err: any) {
      }
   }

   return (
      <>
         <Fade in timeout={900}>
            <Grid container spacing={2}>
               {botaoAnterior && (
                  <Grid item xs={'auto'} style={{
                     display: 'flex',
                     justifyContent: 'center'
                  }}>
                     <Box>
                        <Button
                           variant="contained"
                           color="primary"
                           onClick={async () => await anterior([model.id, ...(model.produto?.adicionais ?? []).map(x => x.produtoId), ...model.produto.inclusos.map(x => x.produtoId)])}
                           style={{
                              height: 55,
                              backgroundColor: (model.minutosDePreparo !== 0) ?
                                 alterarCorStatus() : alterarCorStatusSemMinutos(),
                           }}
                        >
                           <VoltarIcon tipo="BUTTON_PRIMARY" style={{ marginRight: 0 }} />
                        </Button>
                     </Box>
                  </Grid>
               )}

               <Grid item xs={true}>
                  <Card
                     className={classes.prodsCheked}
                     style={{
                        backgroundColor: mostrarCorCard ? corCancelado() : '',
                     }}
                  >

                     <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                     }}>
                        <div style={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                           alignItems: 'center'
                        }}>
                           {!esconderCheckboxSeRetiradaOuEntrega() && model.status.codigo === EnumStatusPedido.AguardandoRetirada && (
                              <Checkbox
                                 onClick={adicionarRemoverProcessos}
                                 color="primary"
                                 checked={!isEmpty(processosSelecionados.find(x => x.produtoId === model.id))}
                              />
                           )}
                           <Typography
                              variant="body1"
                              color="textPrimary"
                           >
                              <Box fontWeight={600}>
                                 {model.produto.quantidade}x
                              </Box>
                           </Typography>
                           <Typography
                              variant="body2"
                              color="textPrimary"
                              style={{
                                 paddingLeft: '8px'
                              }}
                           >
                              {model.produto.descricao}
                           </Typography>
                        </div>

                        <div style={{
                           display: 'flex',
                           justifyContent: 'flex-end'
                        }}>
                           <ClickAwayListener onClickAway={handleCloseTooltip}>
                              <Tooltip
                                 disableFocusListener
                                 disableHoverListener
                                 disableTouchListener
                                 title={`Vendedor: ${model.produto.vendedor}`}
                                 open={openTooltip}
                                 onClose={handleCloseTooltip}
                                 placement="top-end"
                                 arrow
                              >
                                 <Box display="flex" alignItems="center" className={classes.iconInfo}>
                                    <InformacaoIcon
                                       tipo="BUTTON"
                                       fill={mostrarCorCard ? '#666' : theme.palette.text.secondary}
                                       onClick={handleOpenTooltip} />
                                 </Box>
                              </Tooltip>
                           </ClickAwayListener>
                        </div>
                     </div>

                     {!isEmpty(model.produto.observacao) && (
                        <Typography
                           variant="body2"
                           className={classes.obsPedidos}
                        >
                           {`Obs: ${model.produto.observacao}`}
                        </Typography>
                     )}

                     {model.produto.inclusos.map(item => {
                        return (
                           <>
                              <CardInfoProdutoSubItem
                                 produto={item}
                                 qtdPai={model.produto.quantidade}
                              />
                           </>
                        )
                     })}

                     {model.produto.adicionais && model.produto.adicionais.length > 0 && (
                        <Box pl={2}>
                           <Typography
                              variant="caption"
                              color="textSecondary"
                           >
                              <Box fontWeight={700}>
                                 Adicionais
                              </Box>
                           </Typography>
                           <Box pl={.5}>
                              {model.produto.adicionais.map(item => {
                                 return (
                                    <CardInfoProdutoSubItem
                                       produto={item}
                                       qtdPai={model.produto.quantidade}
                                    />
                                 )
                              })}
                           </Box>
                        </Box>
                     )}
                  </Card>
               </Grid>
               {botaoAvancar && (
                  <Grid item xs={'auto'} style={{
                     display: 'flex',
                     justifyContent: 'center'
                  }}>
                     <Box>
                        <Button
                           variant="contained"
                           color="primary"
                           onClick={async () => await proximo([model.id, ...(model.produto?.adicionais ?? []).map(x => x.produtoId), ...model.produto.inclusos.map(x => x.produtoId)])}
                           style={{
                              height: 55,
                              backgroundColor: (model.minutosDePreparo !== 0) ?
                                 alterarCorStatus() : alterarCorStatusSemMinutos(),
                           }}
                        >
                           <AvancarIcon tipo="BUTTON_PRIMARY" style={{ marginRight: 0 }} />
                        </Button>
                     </Box>
                  </Grid>
               )}
               {isConcluido && model.processos.some(x => x.uriConfirmacao) && (
                  <Grid item xs={'auto'} style={{
                     display: 'flex',
                     justifyContent: 'center'
                  }}>
                     <Box>
                        <Tooltip title="Visualizar Assinatura">
                           <Button
                              variant="contained"
                              color="primary"
                              onClick={abrirAssinaturaProduto}
                              style={{
                                 height: 55
                              }}
                           >
                              <AssinaturaIcon tipo="BUTTON_PRIMARY" style={{ marginRight: 0 }} />
                           </Button>
                        </Tooltip>
                     </Box>
                  </Grid>
               )}

               {botaoCancelar && (
                  <Grid item xs={2} style={{
                     display: 'flex',
                     justifyContent: 'center'
                  }}>
                     <Button
                        variant="contained"
                        onClick={async () => await estaCancelado([model.id, ...(model.produto?.adicionais ?? []).map(x => x.produtoId), ...model.produto.inclusos.map(x => x.produtoId)])}
                        style={{
                           height: 55,
                           background: theme.palette.error.main,
                        }}
                     >
                        <CancelIcon tipo="BUTTON_PRIMARY" style={{ marginRight: 0 }} />
                     </Button>
                  </Grid>
               )}
            </Grid>
         </Fade>
         <DialogSaurus
            aberto={isDialogOpenned}
            isButtonTitleClose
            handleClickClose={() => setIsDialogOpenned(false)}
            fullScreen={isMobile}
         >
            <Box style={{
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               textAlign: 'center',
               height: "100%"
            }}>
               <Box>
                  <Typography variant="h6">
                     Assinatura do Cliente
                  </Typography>
                  <Box className={classes.boxAssinatura}>
                     {imagemAssinada && <img src={imagemAssinada} alt="Assinatura" />}
                  </Box>
               </Box>
            </Box>
         </DialogSaurus>
      </>
   )
}

